import Vant from 'vant'
import 'vant/lib/index.css'
import mitt from 'mitt'
import 'normalize.css/normalize.css'
import { createApp } from 'vue'
import App from './App.vue'
import './assets/css/base.less'
import 'virtual:svg-icons-register'
import SvgIcon from './components/SvgIcon/index.vue'
import routers from './router'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import './permission'
// 自定义指令
import { directive } from './utils/directive'
// import print from 'vue3-print-nb'

const app = createApp(App)
const pinia = createPinia()
// pinia 持久化插件
pinia.use(piniaPluginPersistedstate)

app.use(Vant)
app.use(routers)
app.use(pinia)
app.component('SvgIcon', SvgIcon)

directive(app)

// 用于调整是否移除模板中的 HTML 注释。
app.config.compilerOptions.comments = true
app.mount('#app')
